import { Table as AntTable, TableProps } from "antd";

function Table<RecordType extends object>(props: TableProps<RecordType>) {
  return <AntTable rowKey="id" {...props} />;
}

export default Table;
